/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import DefaultRoute from 'shared/client/routes/base';

import Galaxy from 'shared/query/galaxy';
import Config from 'shared/query/config'


export default new Client ([ Config, Galaxy ], class
{
  constructor (config, galaxy)
  {
    this.config = config;
    this.galaxy = galaxy;
  }


  getRoute (route, args)
  {
    const Route = this.config.route[route.getType()] || DefaultRoute;

    const currentLocation = this.galaxy.getLocation(args.current);
    const targetLocation = this.galaxy.getLocation(args.target);

    return new Route(route.getArgs(), this.galaxy, currentLocation, targetLocation);
  }


});
